/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 * 
 ********************************************************************!*/

import { defineComponent } from "vue";

export default defineComponent({
  emits: ["close", "loading", "complete"],
  methods: {
    close() {
      this.$emit("close");
    },
    setLoading(isLoading: boolean) {
      this.$emit("loading", isLoading);
    },
    complete() {
      this.$emit("complete");
    }
  },
});
 